// Get Creator Notes
export const GET_CREATOR_NOTES_REQUEST = 'GET_CREATOR_NOTES_REQUEST';
export const GET_CREATOR_NOTES_DONE = 'GET_CREATOR_NOTES_DONE';
export const GET_CREATOR_NOTES_FAILED = 'GET_CREATOR_NOTES_FAILED';

// Load More Creator Notes
export const LOAD_MORE_CREATOR_NOTES_REQUEST = 'LOAD_MORE_CREATOR_NOTES_REQUEST';
export const LOAD_MORE_CREATOR_NOTES_DONE = 'LOAD_MORE_CREATOR_NOTES_DONE';
export const LOAD_MORE_CREATOR_NOTES_FAILED = 'LOAD_MORE_CREATOR_NOTES_FAILED';

// Create Creator Note
export const CREATE_CREATOR_NOTE_REQUEST = 'CREATE_CREATOR_NOTE_REQUEST';
export const CREATE_CREATOR_NOTE_DONE = 'CREATE_CREATOR_NOTE_DONE';
export const CREATE_CREATOR_NOTE_FAILED = 'CREATE_CREATOR_NOTE_FAILED';

// Update Creator Note
export const UPDATE_CREATOR_NOTE_REQUEST = 'UPDATE_CREATOR_NOTE_REQUEST';
export const UPDATE_CREATOR_NOTE_DONE = 'UPDATE_CREATOR_NOTE_DONE';
export const UPDATE_CREATOR_NOTE_FAILED = 'UPDATE_CREATOR_NOTE_FAILED';

// Remove Creator Note
export const REMOVE_CREATOR_NOTE_REQUEST = 'REMOVE_CREATOR_NOTE_REQUEST';
export const REMOVE_CREATOR_NOTE_DONE = 'REMOVE_CREATOR_NOTE_DONE';
export const REMOVE_CREATOR_NOTE_FAILED = 'REMOVE_CREATOR_NOTE_FAILED';

export const CREATOR_NOTES_RESET = 'CREATOR_NOTES_RESET';
